import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateActionStatus } from '@/features/patient-actions/apis/patientActionsApi'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import {
  ActionStatus,
  Action,
} from '@/features/patient-actions/types/patientActions'

// ========================================
// Types
// ========================================

interface UpdateActionStatusVariables {
  actionId: string
  status: ActionStatus
}

// ========================================
// useUpdateActionStatusMutation
// ========================================

/**
 * アクションステータス更新Mutation（TanStack Query）
 *
 * 責務:
 * - アクションのステータス更新
 * - 成功時にpatientActions関連キャッシュをinvalidate
 *
 * 使用例:
 * ```tsx
 * const updateStatus = useUpdateActionStatusMutation()
 * await updateStatus.mutateAsync({
 *   actionId: 'action-id',
 *   status: 'done',
 * })
 * ```
 */
export const useUpdateActionStatusMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      actionId,
      status,
    }: UpdateActionStatusVariables): Promise<Action> => {
      return await updateActionStatus(actionId, { status })
    },
    onSuccess: () => {
      // アクション一覧のキャッシュをinvalidate
      queryClient.invalidateQueries({
        queryKey: queryKeys.patientActions.list(),
      })
    },
  })
}
